import logger from '../../utils/logger';

export default function EntraApi({ makeRequest, buildRequest }) {
	function searchEntraStaff(searchString, signal) {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Entra/search', {
				params: { searchString },
				signal,
				suppressErrorToast: true,
			}))
		);
	}

	function getEntraStaffPhoto(id, signal) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Entra/${id}/photo`, {
				responseType: 'blob',
				signal,
				suppressErrorToast: true,
				ignoreStatuses: [404],
			})).catch((error) => {
				if (error?.response?.status === 404) return null;
				logger.debug('Error fetching Entra staff photo', error);
				return null;
			})
		);
	}

	return {
		searchEntraStaff,
		getEntraStaffPhoto,
	};
}
